import Footer from "components/sections/Footer";
import SideMenu from "components/sections/SideMenu";
import { Outlet } from "react-router-dom";
import React from "react";

export default function AppLayout() {

  let body = document.getElementsByTagName("body");
  body[0].setAttribute(
    "class",
    "header-tablet-and-mobile-fixed aside-enabled"
  );

  return (
    <div className="page d-flex flex-row flex-column-fluid">
      <SideMenu />

      <div
        className="wrapper d-flex flex-column flex-row-fluid "
        id="wrapper"
      >
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <Outlet />
        </div>
        <Footer />
      </div>
    </div>
  );
}
